import { UPDATE_APPOINTMENT, UPDATE_DATE, UPDATE_TIMESLOT, UPDATE_PERSONAL_INFORMATION, UPDATE_ACTIVEDAY, UPDATE_ACTIVETIMESLOT} from '../actions/types.js';

const INITIAL_STATE = {
	date: null,
	timeslot: {startTime: null, endTime: null},
	firstname: '',
	lastname: '',
	email: '',
	phone: '',
	country: '',
	company: '',
	industry: '',
	companysize: '',
	description: '',
	newsletter: false,
	activeDay: 0,
	activeTimeslot: []
};

const page2 = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE_APPOINTMENT:
			return { 
				...state, 
				appointment: action.payload.appointment,
			}
		case UPDATE_DATE:
			return { 
				...state, 
				date: action.payload.date,
			}
		case UPDATE_TIMESLOT:
			return { 
				...state, 
				timeslot: action.payload.timeslot
			}
		case UPDATE_ACTIVEDAY:
			return { 
				...state, 
				activeDay: action.payload.activeDay
		}
		case UPDATE_PERSONAL_INFORMATION:
			return {
				...state,
				firstname: action.payload.firstname,
				lastname: action.payload.lastname,
				email: action.payload.email,
				phone: action.payload.phone,
				country: action.payload.country,
				company: action.payload.company,
				industry: action.payload.industry,
				companysize: action.payload.companysize,
				description: action.payload.description,
				newsletter: action.payload.newsletter,
				client: action.payload.client,
			}
			case UPDATE_ACTIVETIMESLOT:
				return {
					...state,
					activeTimeslot: action.payload.activeTimeslot
				}

		default:
			return state;
	}
}

export default page2;

